import { useTranslation } from '@hooks/useTranslation';
import { formatRubyAmount, gtagEventTrigger } from '@specs/helpers';
import { StoreItemView } from '@specs/views';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { Button } from '@components/UIKit/Button/Button';
import { LinksEnum } from '@specs/navigation';
import { useToysCart } from '@hooks/useToysCart';
interface Props {
  firstStoreItem: Omit<StoreItemView, 'instanceid'> & {
    instanceid: number;
  };
}
export const BuyToyButton: FC<Props> = ({
  firstStoreItem
}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const {
    addToCartHandler,
    isInCartState
  } = useToysCart({
    toyId: firstStoreItem?.toyid ?? -1
  });
  const {
    currency,
    price
  } = firstStoreItem;
  const currentPrice = currency === 'RUBY' ? formatRubyAmount(price) : price;
  return <>
            {!isInCartState ? <Button id={currency === 'GOLD' ? 'toy_card_in_cart_gold_button' : 'toy_card_in_cart_ruby_button'} size={'medium'} color={'Black'} onClick={() => {
      addToCartHandler(firstStoreItem);
    }} icons={{
      left: {
        name: currency === 'GOLD' ? 'gold' : 'ruby'
      }
    }}>
                    {currentPrice}
                </Button> : <Button id='toy_card_go_to_basket_button' size={'medium'} color={'White'} onClick={async () => {
      gtagEventTrigger({
        action: 'go_to_basket',
        category: 'commercial'
      });
      await router.push(LinksEnum.CART_TOYS);
    }} icons={{
      left: {
        name: 'cart'
      }
    }}>
                    {tr({
        id: 'btn.go.to.cart'
      })}
                </Button>}
        </>;
};